import {IndexedDBCache} from "./indexed_db_cache";

export async function fetchAndCacheImage(
  url: string,
  cache: IndexedDBCache
): Promise<HTMLImageElement> {
  // Check cache first
  const cachedBlob = await cache.get(url);

  if (cachedBlob) {
    // Create an image element from the cached blob
    return createImageFromBlob(cachedBlob);
  } else {
    // Fetch the image from the network
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch image: ${response.statusText}`);
    }
    const blob = await response.blob();

    // Cache the image
    await cache.set(url, blob);

    // Create an image element from the fetched blob
    return createImageFromBlob(blob);
  }
}

export function createImageFromBlob(blob: Blob): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(blob);
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = (error) => {
      URL.revokeObjectURL(url);
      reject(new Error('Failed to load image'));
    };
    img.src = url;
  });
}

export async function fetchAndCacheBlob(
  url: string,
  cache: IndexedDBCache
): Promise<Blob> {
  // Check cache first
  const cachedBlob = await cache.get(url);

  if (cachedBlob) {
    return cachedBlob;
  } else {
    // Fetch the blob from the network
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch blob: ${response.statusText}`);
    }
    const blob = await response.blob();

    // Cache the blob
    await cache.set(url, blob);

    return blob;
  }
}

